<template>
  <div class="zm-checkbox-group" role="group" :class="[size ? 'zm-checkbox-group--' + size : '']">
    <slot></slot>
  </div>
</template>

<script>
  import Emitter from '../../mixins/emitter';

  export default {
    name: 'ZmCheckboxGroup',

    componentName: 'ZmCheckboxGroup',

    mixins: [Emitter],

    inject: {
      ZmFormItem: {
        default: ''
      }
    },

    props: {
      value: Array,
      disabled: Boolean,
      size: {
        type: String,
        default: 'small'
      }
    },

    computed: {
      _elFormItemSize() {
        return (this.ZmFormItem || {}).elFormItemSize;
      },
      checkboxGroupSize() {
        return this._elFormItemSize || (this.$ELEMENT || {}).size || this.size;
      }
    },

    watch: {
      value(value) {
        this.dispatch('ZmFormItem', 'el.form.change', [value]);
      }
    }
  };
</script>

<style lang="scss">
@import "./style";
</style>
